import integerWithThousandSeparator from 'shared-utils/src/integerWithThousandSeparator';

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'onsliderchange':     
      return {
        ...state,
        slider: payload.slider,
        inputs: payload.inputs,
      };
    case 'oninputfocus': 
      return {
        ...state,
        focus: payload.focus,
      };      
    case 'oninputchange': 
      return {
        ...state,
        inputs: payload.inputs,
      };
    case 'oninputblur': 
      const hasSliderValues = payload.slider
        ? { slider: payload.slider }
        : {};
      return {
        ...state,
        focus: payload.focus,
        ...hasSliderValues,
      };  
    default:
      return state;    
  }
};

const ensureValIsNnum = (value) => parseInt(value.toString().replace(/\./g, ''), 10)

export const getValueIndex = (value, values) => {
  const numValue = ensureValIsNnum(value);
  return values.indexOf(numValue) > -1
    ? values.indexOf(numValue)
    : values.filter(val => parseInt(val, 10) <= numValue).length - 1;
};

export const getInitialSliderValues = (min, max, values) => {
  const minVal = min ? getValueIndex(min, values) : 0; 
  const maxVal = max ? getValueIndex(max, values) : values.length;
  return [minVal, maxVal];
};

export const getValuesOnSliderChange = (newIndexs, values, state) => {
  let min;
  let max; 
  let newSliderValues = [];

  const isMin = newIndexs[1] === state.slider[1];

  if (isMin) {
    min = newIndexs[0] !== 0
      ? integerWithThousandSeparator(parseInt(values[newIndexs[0]], 10))
      : '';
    max = state.inputs.max;
    newSliderValues = [newIndexs[0], state.slider[1]];
  } else {
    min = state.inputs.min;
    max = newIndexs[1] !== values.length
      ? integerWithThousandSeparator(parseInt(values[newIndexs[1]], 10))
      : '';
    newSliderValues = [state.slider[0], newIndexs[1]];
  }

  return {
    newInputsValues: { min, max },
    newSliderValues,
  };
};